import { GetterTree } from 'vuex';
import { TourState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<TourState, RootState> = {
  currentTour: (state) => {
    return state;
  },
  step: (state) => {
    const { steps, currentStep } = state;
    return currentStep >= 0 ? steps[currentStep] : null;
  },
  currentStep: (state) => {
    return state.currentStep;
  },
  hasNextStep: (state) => {
    return !(state.currentStep === state.numberOfSteps - 1);
  },
  hasPreviousStep: (state) => {
    return !(state.currentStep === 0);
  },
  isTourActive: (state) => {
    return state.isActive;
  },
  numberOfSteps: (state) => {
    return state.numberOfSteps;
  },
  intervalId: (state) => {
    return state.intervalId || '';
  },
  lastStepIsInAnotherPage: (state) => {
    const { steps, currentStep } = state;
    return !!steps[currentStep].lastStepIsInAnotherPage;
  },
};

export default getters;
